import DirectionServicesView from '@/components/DirectionServicesView';

export default function DirectionPage(props) {
  const { slug, directions, banners, short_content } = props;

  return (
    <DirectionServicesView
      banners={banners}
      directions={directions}
      short_content={short_content}
      activeSlug={slug}
    />
  );
}
